var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailOpenOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.6667V6.71333C1.99997 6.49388 2.0541 6.27781 2.15761 6.08429C2.26111 5.89077 2.41078 5.7258 2.59333 5.604L7.26 2.49333C7.47911 2.34715 7.7366 2.26913 8 2.26913C8.2634 2.26913 8.52089 2.34715 8.74 2.49333L13.4067 5.604C13.5892 5.7258 13.7389 5.89077 13.8424 6.08429C13.9459 6.27781 14 6.49388 14 6.71333V12.6667M2 12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667M2 12.6667L6.5 9.66667M14 12.6667L9.5 9.66667M6.5 9.66667L2 6.66667M6.5 9.66667L7.26 10.1733C7.47911 10.3195 7.7366 10.3975 8 10.3975C8.2634 10.3975 8.52089 10.3195 8.74 10.1733L9.5 9.66667M9.5 9.66667L14 6.66667",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOpenOutline);
export default __webpack_public_path__ + "static/media/MailOpenOutline.798e26617a99971210041af9c36ad708.svg";
export { ForwardRef as ReactComponent };